import styled from 'styled-components'

export const ProjectsList = styled.div`
  border-bottom: 2px solid var(--clr-dark);
  position: relative;
`